import React from "react";
import { GraphicElementWithNid } from "../GraphicElement";
import { CategoryContext } from "../Context";
import { Category } from "../processors";

interface CategoryContentProps {
    graphicElementIds?: number[];
    category?: Category;
}

export const CategoryContent: React.FC<CategoryContentProps> = ({ category, graphicElementIds }) => {
    return (
        <CategoryContext.Provider
            value={{
                category
            }}
        >
            {graphicElementIds
                ?.filter(d => d != null && d.toString().trim() !== "")
                ?.map((d, index) => (
                    <GraphicElementWithNid
                        nid={d}
                        // key={d}
                        key={index}
                    />
                ))}
        </CategoryContext.Provider>
    );
};
